/**
 * used to transform list of banks.
 *
 * @param bankList
 * @returns {Array}
 *
 * [ used primarily in ./downBankListTransformer.js && paymentCreationInfoTransformer.js ]
 */

import { bankTransformer } from './bankTransformer';


export const bankListTransformer = (bankList: any) => {
  let transformedArray: never[] = [];
  if (!bankList || !bankList.length) {
    return transformedArray;
  }

  transformedArray = bankList.map((bank: any) => bankTransformer(bank));

  return transformedArray;
};
